import { $ } from 'lib/query-selector'
import stimulus from 'lib/stimulus-instance'
import InvitationCode from 'frontend/pages/rooms/titanic/invitation-code-controller'
import HhlaPageBase from './hhla-page-base'

stimulus.register('invitation-code', InvitationCode)

export default class TitanicPage extends HhlaPageBase {
  static handleStylesApplied () {
    this.onEnter('.video_container', this.initVideo.bind(this))
  }

  static handleCodeValid () {
    const scheduleSectionEl = $('#schedule')
    scheduleSectionEl.style.display = null
    setTimeout(() => {
      scheduleSectionEl.scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  }

  static handleDOMReady () {
    this.mountRoomSchedule()
    window.addEventListener('invitation-code:valid', () => this.handleCodeValid())
  }
}

TitanicPage.init()
